const DEFAULT = 'ACTIVE.com';

export const companiesMapping = {
  'Active Network, LLC': [ 'AUD', 'BRL', 'CNY', 'INR', 'JPY', 'KRW', 'MXN', 'MYR', 'PHP', 'PLN', 'THB', 'TWD', 'USD' ],
  'The Active Network (EU) Ltd': [ 'CHF', 'DKK', 'EUR', 'GBP', 'HKD', 'NOK', 'NZD', 'SEK', 'SGD' ],
  'The Active Network, Ltd': [ 'CAD' ],
};

const currenciesMapping = Object.keys(companiesMapping)
  .map(key => companiesMapping[key].map(currency => ({ [currency]: key })))
  .flat()
  .reduce((acc, entry) => ({ ...acc, ...entry }), {});

export const currenciesConfig = name => currenciesMapping[name] || DEFAULT;
